import { render } from "./DropdownVesting.vue?vue&type=template&id=1730cece"
import script from "./DropdownVesting.vue?vue&type=script&lang=ts"
export * from "./DropdownVesting.vue?vue&type=script&lang=ts"
script.render = render

export default script